import dateFns from 'date-fns';
import _ from 'lodash';

export default class HourMinutes {
  constructor(value) {
    let date;

    if (Number.isInteger(value)) {
      /**
       * Date 객체일 경우
       */
      this.hour = Math.floor(value / 60);
      this.minutes = value % 60;

      return;
    }

    if (value instanceof Date) {
      /**
       * Date 객체일 경우
       */
      this.hour = dateFns.getHours(value);
      this.minutes = dateFns.getMinutes(value);

      return;
    }

    if (typeof value === 'string') {
      if (value.length === 5) {
        this.hour = Number.parseInt(value.split(':')[0]);
        this.minutes = Number.parseInt(value.split(':')[1]);

        return;
      }

      date = new Date(value);
    }

    if (date instanceof Date) {
      /**
       * Date 객체일 경우
       */
      this.hour = dateFns.getHours(date);
      this.minutes = dateFns.getMinutes(date);

      return;
    }
  }

  isAfter(compareInstance) {
    return this.toMinutes() > compareInstance.toMinutes();
  }

  isBefore(compareInstance) {
    return this.toMinutes() < compareInstance.toMinutes();
  }

  isEqual(compareInstance) {
    return this.toMinutes() === compareInstance.toMinutes();
  }

  toString() {
    return `${to2Digit(this.hour)}:${to2Digit(this.minutes)}`;
  }

  toMinutes() {
    return this.hour * 60 + this.minutes;
  }

  static dateToMinutes(date) {
    const hourMinutes = new HourMinutes(date);

    return hourMinutes.toMinutes();
  }
}

function to2Digit(num) {
  return _.padStart(num, 2, '0');
}
